import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { fadeIn } from 'src/app/animations';
import { FormTemplate } from 'src/app/models/forms/form-template.model';
import { Job } from 'src/app/models/job.model';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { SettingsPreferences } from 'src/app/services/ui/models/settings-preferences.model';
import { ButtonIcons } from '../action-button/models/button-icons.enum';
import { ActionsPlaceholderSettings } from 'src/app/models/enum/actions-placeholder-settings.enum';
import { ValueStore } from 'src/app/add-ons/react-form/redux/list.store';
import { FormViewerComponent } from '../form-viewer/form-viewer.component';
import { GenericModalComponent } from '../generic-modal/generic-modal.component';
import { FormsService } from 'src/app/services/sections/job/forms.service';
import { FormResponse } from 'src/app/models/forms/form-response.model';
import { TokenHelper } from 'src/app/services/helpers/token.helper';
import * as moment from 'moment';

@Component({
	selector: 'forms',
	templateUrl: './forms.component.html',
	styleUrls: ['./forms.component.scss', '../stylesheets/job-actions.scss', '../stylesheets/job-main.scss', '../stylesheets/job-inputs.scss', '../stylesheets/forms-container.scss', '../stylesheets/job-form.scss'],
	animations: [fadeIn(200)]
})
export class FormsComponent implements OnInit, AfterViewInit {

	@ViewChild('formsModal', { static: true }) public modal: GenericModalComponent;

	public currentFormViewer: FormViewerComponent;

	public reactComponentId: string;

	public formTemplates: FormTemplate[];

	public selectedFormTemplate: FormTemplate;

	public job: Job;
	public customerPreferences: SettingsPreferences;
	public formsBeingSaved: { [key: number]: boolean } = {};

	public form: FormGroup;

	public readonly ActionsPlaceholderSettings = ActionsPlaceholderSettings;
	public readonly ButtonIcons = ButtonIcons;
	public readonly self = this;
	public moment = moment;

	constructor(
		private activatedRoute: ActivatedRoute,
		private formsService: FormsService
	) { }

	ngOnInit(): void {
		this.formTemplates = this.activatedRoute.snapshot.data.formTemplates;
		this.job = (this.activatedRoute.snapshot.data.jobDetails || {}) as Job;
		this.customerPreferences = this.activatedRoute.snapshot.data.customerPreferences as SettingsPreferences;

		this.formTemplates.forEach(item => {
			item.formDataObj = JSON.parse(item.formData);
			item.jsonSchemaObj = JSON.parse(item.jsonSchema);
			item.defaultUISchemaObj = JSON.parse(item.defaultUISchema);
		});
	}

	ngAfterViewInit(): void {
		GlobalSettingsService.isGlobalLoaderLoading = false;
		GlobalSettingsService.isSecondaryLoaderLoading = false;
	}

	public onSubmit(store: ValueStore) {
		const storeState = store.store.getState();
		const jsonSchemaData = storeState.FormData ? JSON.stringify(storeState.FormData) : null;

		this.formsBeingSaved[this.selectedFormTemplate.formTemplateId] = true;

		const response: FormResponse = {
			jobFormResultId: this.selectedFormTemplate.jobFormResultId,
			formTemplateId: this.selectedFormTemplate.formTemplateId,
			formResult: jsonSchemaData,
			jobId: this.job.jobId,
			jobSourcingTierId: this.selectedFormTemplate.jobSourcingTierId,
			jobResourceId: this.selectedFormTemplate.jobResourceId
		};

		this.formsService.addFormResponse(TokenHelper.getToken(this.activatedRoute), response)
			.subscribe(({ lastUpdatedBy, jobFormResultId, collectedOn }) => {
				const formTemplate = this.formTemplates.find(item => item.formTemplateId === response.formTemplateId);

				if (formTemplate) {
					formTemplate.jobFormResultId = jobFormResultId;
					formTemplate.formData = response.formResult;
					formTemplate.formDataObj = JSON.parse(formTemplate.formData);
					formTemplate.collectedBy = lastUpdatedBy;
					formTemplate.collectedOn = collectedOn;
				}

				this.formsBeingSaved[formTemplate.formTemplateId] = false;
			});

		if (this.modal) {
			this.modal.hide();
		}

		this.selectedFormTemplate = null;
		this.currentFormViewer = null;
	}

	public resetSelection(): void {
		if (this.modal) {
			this.modal.hide();
		}

		this.selectedFormTemplate = null;
		this.currentFormViewer = null;
	}

}
